/*
 * Created by PoornachandraPulluru on 23/02/17.
 */
import extend from 'extend';
import map from 'lodash/map';
import Cookies from '../Cookies/Cookies';
import LocalStorage from '../LocalStorage/LocalStorage';
import Constants from '../../common/Constants';
import getConfig from '../Config/Config';

/**
 * util function to read URL params
 * @param {string} key - query parameter name
 * @param {http url} url (optional) - soruce of url to read params
 */
const getURLParameterBykey = (key, url = window.location.href) => {
    // TODO - this will moved to Util function later
    let name = key;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ''));
};

const getFormErrorDL = (errorDetails) => {
    errorDetails = map(errorDetails, (error) => {
        if (error && error.errorDescription && error.errorDescription.length > 255) {
            error.errorDescription = error.errorDescription.slice(0, 255);
        }
        return error;
    });
    return { error: errorDetails };
};

const getNavigationDL = (payload) => {
    let navDL = null;
    const linkName = (payload.linkName || '').toLowerCase();
    if (payload.isReload) {
        Cookies.save('navigationClickDigitalData', linkName);
    } else {
        navDL = {
            page: {
                pageInfo: {
                    linkName,
                },
            },
        };
    }
    return navDL;
};

const getPendingNavigationDL = () => {
    const linkName = Cookies.load('navigationClickDigitalData');
    let navDL = null;
    if (linkName) {
        navDL = {
            page: {
                pageInfo: {
                    linkName,
                },
            },
        };
    }
    return navDL;
};

// To know the viewport size for page. values can be: small | medium | large | x-large
const getViewportSize = (window) => {
    let viewportSize = '';
    if (window && window.innerWidth) {
        const width = window.innerWidth;
        if (width < 600) {
            viewportSize = 'small';
        } else if (width >= 600 && width < 1024) {
            viewportSize = 'medium';
        } else if (width >= 1024 && width < 1440) {
            viewportSize = 'large';
        } else {
            viewportSize = 'x-large';
        }
    }
    return viewportSize;
};

// To know from where the request is served, either from Legacy Adapter or from microservices
// This code is no longer need once we have micro services serving 100% of Yoda
const getDebugSource = () => {
    const debugSource = [];
    const getCookie = Cookies.load('Aurora'); // <== Zuul will drop a cookie before redirecting to either MS or LA
    const dpcptCookie = Cookies.load('DPCPT'); // <== Akamai drops this cookie to determine traffic
    let auroraCookie = 'legacy atg';
    if (getCookie) {
        const getDebuggerValue = getCookie.split('|');
        auroraCookie = getDebuggerValue && getDebuggerValue[0] ? getDebuggerValue[0] : '';
    }
    if (dpcptCookie) {
        const dpcptCookieValue = dpcptCookie.split('|');
        const dpcptCookiesMap = getConfig(
            'context.preferences.DPCPT_COOKIES',
            Constants.DPCPT_COOKIES
        );
        for (let i = 0; i < dpcptCookieValue.length; i += 1) {
            if (dpcptCookiesMap[dpcptCookieValue[i].trim()]) {
                debugSource.push(dpcptCookiesMap[dpcptCookieValue[i].trim()]);
            }
        }
    }
    debugSource.push(`checkout platform=${auroraCookie}`);
    debugSource.push('feDesign=Apollo');
    return debugSource;
};

const isDeviceTouchEnabled = () => {
    /* istanbul ignore else */
    if (!__SERVER__) {
        return (
            'ontouchstart' in window ||
            navigator.MaxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0
        );
    }
    return false;
};

const constructStoreId = () => {
    const userPreferredStore = Cookies.load('userPreferredStore') || '';
    try {
        if (!userPreferredStore) return '';
        const storeDetails = JSON.parse(decodeURI(userPreferredStore));
        return `${storeDetails?.storeId}|${storeDetails?.storeName}|${storeDetails?.distance}`;
    } catch (error) {
        console.info('Error in constructing StoreId:', error);
        return '';
    }
};

const updateCommonDigitalData = (digitalData, context) => {
    const profileOptin = Cookies.load('omni_profileOptin', true);

    let emailOptIn = '';
    const mobileOptIn = [];
    /* istanbul ignore else */
    if (profileOptin) {
        const emailOptInMapping = {
            Y: 'yes',
            NA: 'no selection',
            N: 'no',
        };
        Object.keys(emailOptInMapping).every((key) => {
            if (profileOptin.startsWith(key)) {
                emailOptIn = emailOptInMapping[key];
                return false;
            }
            return true;
        });
        /* istanbul ignore else */
        if (profileOptin.split('|').length >= 2) {
            const mobileOptInData = profileOptin.split('|')[1];
            if (mobileOptInData.startsWith('NA')) {
                mobileOptIn.push('no selection');
            } else if (mobileOptInData.startsWith('N')) {
                mobileOptIn.push('no');
            } else {
                if (mobileOptInData.indexOf('P') !== -1) {
                    mobileOptIn.push('promotional');
                }
                if (mobileOptInData.indexOf('T') !== -1) {
                    mobileOptIn.push('transactional');
                }
            }
        }
    }

    const omniProfileType = Cookies.load('omni_profileType', true);
    const profileType = [];
    let rewardsFlag = 'no';
    let rewardsMemberType = '';
    if (omniProfileType) {
        const rewardsMemberTypeMapping = {
            'R-S': 'silver',
            'R-G': 'gold',
            'R-P': 'platinum',
            'R-R': 'red',
            'R-B': 'base',
        };
        Object.keys(rewardsMemberTypeMapping).every((key) => {
            if (omniProfileType.indexOf(key) !== -1) {
                rewardsMemberType = rewardsMemberTypeMapping[key];
                return false;
            }
            return true;
        });

        const profileTypeArray = omniProfileType.split('|');
        if (profileTypeArray.length >= 1 && profileTypeArray[0] === 'A') {
            profileType.push('active');
        }

        if (profileTypeArray.length >= 2 && profileTypeArray[1] === 'C') {
            profileType.push('credit');
        }

        if (profileTypeArray.length >= 4 && profileTypeArray[3] === 'L') {
            profileType.push('lapsed');
        }
    }
    const userState = Cookies.load('DP_USER_STATE', true) || '0';
    const isLoggedIn = userState !== '0';
    if (isLoggedIn) {
        if (LocalStorage.getData('DP_REWARDS_TIER')) {
            rewardsMemberType = LocalStorage.getData('DP_REWARDS_TIER');
        } else if (
            LocalStorage.getData('DP_REWARDS_STATUS') &&
            LocalStorage.getData('DP_REWARDS_STATUS') === 'Enrolled'
        ) {
            rewardsMemberType = 'base';
        } else if (
            LocalStorage.getData('DP_REWARDS_STATUS') &&
            LocalStorage.getData('DP_REWARDS_STATUS') === 'Pending'
        ) {
            rewardsMemberType = LocalStorage.getData('DP_REWARDS_STATUS');
        }
    }

    const profileID = Cookies.load('DYN_USER_ID', true) || LocalStorage.getData('ACCOUNT_ID') || '';
    if (isLoggedIn) {
        if (rewardsMemberType) {
            profileType.push('rewards');
            rewardsFlag = 'yes';
        } else {
            rewardsFlag = 'no';
        }
    }

    const profileAttr = Cookies.load('omni_profileAttr', true) || '';
    // PriceZone: https://jira.jcpenney.com/browse/MNPDPYODA-2719?filter=25157
    const regionID = Cookies.load('UPZ') || 0; // If no regionId found set it to zero

    const expressCheckoutValue = profileAttr.startsWith('Y') ? 'yes' : 'no';
    const expressCheckoutEnabled = isLoggedIn ? expressCheckoutValue : '';

    let associateFlag = '';
    let profileAttrArray = [];
    if (profileAttr) {
        profileAttrArray = profileAttr.split('|');
    }
    if (profileAttrArray.length >= 2) {
        associateFlag = profileAttrArray[1] === 'Y' ? 'yes' : 'no';
    }

    const ItemTotal = LocalStorage.getData('cartTotal') || '0.00';
    let analyticsCustState = LocalStorage.getData('ANALY_CUST_STATE');
    let breadCrumbData = '';
    let activeAnalyticsData = '';
    try {
        breadCrumbData = Cookies.load('breadCrumbClickDigitalData', true);
        activeAnalyticsData = Cookies.load('activeAnalyticsData', true);
    } catch (error) {
        console.log('decoding breadcrumb Cookie error', error);
    }
    if (breadCrumbData && activeAnalyticsData !== breadCrumbData) {
        activeAnalyticsData = encodeURIComponent(breadCrumbData);
        Cookies.save('activeAnalyticsData', activeAnalyticsData);
    }
    if (analyticsCustState === null || analyticsCustState === '') {
        analyticsCustState = LocalStorage.getData('DP_USER_STATE') === '1' ? 'logged-in' : 'guest';
    }
    const commonDigitalData = {
        isReady: true,
        cart: {
            attributes: {
                cartTotal: ItemTotal ? ItemTotal.replace('$', '') : '0.00',
            },
        },
        error: [],
        dataVersion: 1,
        user: {
            // @TODO from where we can get this information.
            profile: {
                profileInfo: {
                    mobileOptIn,
                    // customerType: '', // not available in wiki
                    teaLeafID: Cookies.load('TLTSID') || '',
                    rewardsMemberType,
                    associateFlag,
                    customerState: analyticsCustState,
                    rewardsFlag,
                    emailOptIn,
                    profileID,
                    profileType, // @TODO Need more details from tagging team
                    storeID: constructStoreId().toLowerCase(),
                    itemsInSaveForLater: Cookies.load('DP_USER_FAVCOUNT') || '0',
                    visitorID:
                        Cookies.load('cmvid', true) || LocalStorage.getData('DP_VISITOR_ID') || '',
                    expressCheckoutEnabled,
                    regionID: regionID.toString(),
                },
            },
        },
        page: {
            attributes: {
                internalCampaignID: getURLParameterBykey('cm_re') || '',
                debugSource: getDebugSource(),
                ...(activeAnalyticsData && { breadcrumbs: activeAnalyticsData }),
            },
            pageInfo: {
                currency: (Cookies.load('shipToCurrencyCode') || 'USD').toLowerCase(), // @TODO - we have to read from cookie and set this value
                country: (Cookies.load('shipToCountry') || 'US').toLowerCase(), // @TODO - we have to read from cookie and set this value
                clusterInstance: Cookies.load('DPInstance') || '',
                pageViewport: getViewportSize(window),
                deviceTouchEnabled: isDeviceTouchEnabled() ? 'yes' : 'no',
                serviceWorkerInstalled: window.isServiceWorkerInstalled ? 'yes' : 'no',
            },
        },
    };
    //  MCYODA-20842 => Keep me logged in DA
    if (userState === '1' && LocalStorage.getData(Constants.DP_KEEP_ME_LOGGED) === '1') {
        commonDigitalData.user.profile.profileInfo.stayLoggedInChoice = 'yes';
    }
    if (!ItemTotal && Cookies.load('DP_ORDER_INFO')) {
        const cartTotalCookie = Cookies.load('DP_ORDER_INFO');
        let cartTotal = [];
        if (cartTotalCookie && cartTotalCookie !== undefined) {
            cartTotal = cartTotalCookie.split('|'); // for desktop setting cartTotal value from DP_ORDER_INFO cookie
        }

        commonDigitalData.cart.attributes.cartTotal =
            (cartTotal[1] || '').replace('$', '') || '0.00';
    }
    if (commonDigitalData.user.profile.profileInfo.storeID) {
        const storeId = commonDigitalData.user.profile.profileInfo.storeID.split('|')[0]; // for desktop setting cartTotal value from DP_ORDER_INFO cookie
        if (storeId === 'null') {
            commonDigitalData.user.profile.profileInfo.storeID = '';
        }
    }
    const { page: { pageInfo: { deviceType = '' } = {} } = {} } = digitalData || {};
    if (
        (deviceType && deviceType !== 'desktop') ||
        (context && context.deviceType && !context.deviceType.isDesktop)
    ) {
        commonDigitalData.page.pageInfo.pageOrientation =
            Math.abs(window.orientation) === 90 ? 'landscape' : 'portrait';
    }

    return extend(true, commonDigitalData, digitalData || {});
};

const selectStoreData = () => ({
    user: {
        profile: {
            profileInfo: {
                storeID: constructStoreId().toLowerCase(),
            },
        },
    },
});

const storeSearchData = (payload) => ({
    store: {
        searchText: payload.address,
    },
});
const loadBreadCrumbData = (breadCrumbData) => {
    const { totalnumber, clickedCrumbPosition, difference, breadCrumbs } = breadCrumbData;
    const breadCrumbsDisplayed = breadCrumbs && breadCrumbs.toLowerCase();
    const breadCrumbAnalyticsData = encodeURIComponent(
        `${totalnumber}|${clickedCrumbPosition}|${difference}|${breadCrumbsDisplayed}`
    );
    Cookies.save('breadCrumbClickDigitalData', breadCrumbAnalyticsData);
    updateCommonDigitalData();
    return {
        page: {
            attributes: {
                breadcrumbs: breadCrumbAnalyticsData,
            },
        },
    };
};

const videoLoadedData = (payload) => ({
    video: payload.video,
    product: payload.product,
});

const openModelData = (name) => ({
    page: {
        pageInfo: {
            name,
        },
    },
});

const captureRecommendationsScheme = (payload) => ({
    page: {
        pageInfo: {
            productStrategy: payload.productStrategy,
        },
    },
});

const getNonCustomerFacingErrors = (errorObj) => {
    let pageDL = {};
    if (errorObj && !__SERVER__) {
        pageDL = {
            page: {
                pageInfo: {
                    pageURL: window.location.href,
                    pageType: errorObj.pageType.toLowerCase(),
                    errorType: errorObj.errorType,
                    errorInfo: errorObj.errorDescription,
                    errorMessage: errorObj?.error?.message || '',
                    errorStack: errorObj?.error?.stack || '',
                    errorComponentStack: errorObj?.error?.componentStack || '',
                },
            },
        };
    }
    return pageDL;
};

const successfulSubscriptionData = (payload) => ({
    preferences: [
        {
            optinType: payload?.optinType,
            optinFlag: payload?.optinFlag || 'yes',
            notificationType: 'marketing',
            source: payload?.source || 'page footer',
        },
    ],
});

class BaseActionFilter {
    constructor() {
        this.getURLParameterBykey = getURLParameterBykey; // TODO - once this function moved to yoda core util, we should removed from here also.
        this.getFormErrorDL = getFormErrorDL;
        this.getNavigationDL = getNavigationDL;
        this.getPendingNavigationDL = getPendingNavigationDL;
        this.updateCommonDigitalData = updateCommonDigitalData;
        this.selectStoreData = selectStoreData;
        this.storeSearchData = storeSearchData;
        this.videoLoadedData = videoLoadedData;
        this.openModelData = openModelData;
        this.getViewportSize = getViewportSize;
        this.getNonCustomerFacingErrors = getNonCustomerFacingErrors;
        this.captureRecommendationsScheme = captureRecommendationsScheme;
        this.loadBreadCrumbData = loadBreadCrumbData;
        this.successfulSubscriptionData = successfulSubscriptionData;
    }
}

export default BaseActionFilter;
